import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../../utils/Utils.js';
import ProjectDropdown from '../dropdowns/ProjectDropdown.js';
import './LotProject.css';

// LotProjectField is the optional "Projects" picker on the add-lot forms (all
// lot types). The value is an array of project _ids; the API checks and
// links them when the lot is created. Picking a project in the dropdown adds
// it as a chip (× removes it). Hidden when the ranch has no active project —
// the lot page can still link some later.
const LotProjectField = ({ value, onChange, groupClassName }) => {
  const { t } = useTranslation();
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    Fetch('api/finance/projects', 'GET', null, (data) => setProjects(data || []), () => {});
  }, []);

  const active = projects.filter(p => p.status !== 'closed');
  if (active.length === 0) return null;

  const selected  = value || [];
  const available = active.filter(p => !selected.includes(p._id));

  return (
    <div className={groupClassName} data-testid="lot-project-field">
      <label htmlFor="lot-project">{t('lot_projects_optional')}</label>
      {selected.length > 0 && (
        <div className="lot-project-chips">
          {selected.map(id => {
            const p = projects.find(x => x._id === id);
            return (
              <span className="lot-project-chip" key={id}>
                {p ? `${p.code} — ${p.name}` : id}
                <button type="button" onClick={() => onChange(selected.filter(x => x !== id))}
                  aria-label={t('remove')} title={t('remove')}>×</button>
              </span>
            );
          })}
        </div>
      )}
      {available.length > 0 && (
        <ProjectDropdown id="lot-project" projects={available} selected=""
          onChange={e => e.target.value && onChange([...selected, e.target.value])} />
      )}
    </div>
  );
};

export default LotProjectField;
